import BackofficeIndexBase from './BackofficeIndexBase.js';

export default class BackofficeMoeOrdersIndex extends BackofficeIndexBase {
  constructor() {
    super('#moe-orders-datatable');

    this.bindEvents();
  }

  bindEvents() {
    // No step dropdown or saved filters for MOE orders index
  }

  onDataChanged() {
    // Custom logic for MOE orders
  }
}
